export default __webpack_public_path__ + "static/media/labour-day-cn.e976dfed.webp";